// Source: SocialProofWidget. Values include intentional inline spacing.
const en = {
  "s1": "GitHub Stars",
  "s2": "Docker Pulls",
  "pulls": "100K+"
};
const pt: typeof en = {
  "s1": "Estrelas no GitHub",
  "s2": "Pulls no Docker",
  "pulls": "100 mil+"
};
export default { en, 'pt-BR': pt };
